var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-header"},[_c('div',{staticClass:"content-search",staticStyle:{"width":"auto"}},[_vm._v(" "+_vm._s(_vm.txt)+" ")]),_c('nav',{staticClass:"nav"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }